import { format } from 'date-fns';
import { useIntl } from 'react-intl';

import { IConfigOffer, ILoyaltyBetweenDates } from 'generated/sanity-graphql';

const formatDate = (date: string) => format(new Date(date), 'M/d');

export const useConfigOfferDateRangeMessage = (configOffer?: Pick<IConfigOffer, 'rules'>) => {
  const { formatMessage } = useIntl();

  if (!configOffer) {
    return '';
  }

  const { startDate, endDate } =
    configOffer?.rules?.find(
      (rule): rule is ILoyaltyBetweenDates => !!rule && rule.__typename === 'LoyaltyBetweenDates'
    ) || {};

  if (startDate && endDate) {
    return formatMessage(
      { id: 'fromStartDateToEndDate', defaultMessage: 'From {startDate} to {endDate}' },
      {
        startDate: formatDate(`${startDate}T00:00:00`),
        endDate: formatDate(`${endDate}T23:59:59`),
      }
    );
  }

  return '';
};
